<div class="modal-header justify-content-center mdlb-sum-modal-header">
  <h1 class="title title-up">{{'reservation.dailySum.title' | translate}}</h1>
  <button aria-hidden="true" class="close" data-dismiss="modal" type="button" (click)="close()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<div class="modal-body" *ngIf="dailySum">
  <div class="row">
    <div class="col-xs-12 col-sm-9 col-md-12 col-lg-8 col">
      <div>
        <span>{{"reservation.dailySum.personCount" | translate}}: {{dailySum.personCount}}</span>
      </div>
      <div>
        <span>{{"reservation.dailySum.diyCount" | translate}}: {{dailySum.diyCount}}</span>
      </div>
      <hr/>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 col makery-food-section">
      <h3>{{'reservation.dailySum.foodHeding' | translate}}</h3>
      <ul>
        <li *ngFor="let diyNameAndCount of dailySum.numberOfDiysByName | keyvalue">
          <div class="row ">
            <div class="col-12">
              <span> {{diyNameAndCount.value}} x {{diyNameAndCount.key}}</span>
            </div>
          </div>
        </li>
      </ul>

    </div>
  </div>
</div>
